import Enum from "./Enum";

export default Enum.create( {
	CONNECTIONS: "CONNECTIONS",
	FEEDBACK: "FEEDBACK",
	TEAM_PERFORMANCE: "TEAM_PERFORMANCE",
	EFFECTIVE_MEETINGS: "EFFECTIVE_MEETINGS",
	COACHING: "COACHING",
	OTHER: "OTHER",
} );
